export const useFeedbackStore = defineStore('feedbacks', {
    state: () => ({
        feedbacks: [],
        feedback: null
    }),
    actions: {
        async createFeedback(body: any) {
            const { $api } = useNuxtApp()
            return $api().v2.mission_feedback.create(body).then((response) => {

                this.feedbacks.push(response);

                return response
            })
        }
    }
})